import * as React from "react";
import { Box, Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { RootState } from "../../app/store";
import { setTalentFilter } from "../../app/uiSlice";
import useDebounce from "../../hooks/useDebounce";
import SelectCountry from "../../components/SelectCountry";
import SelectSkills from "./SelectSkills";
import { BaseModal, Button, StyledTextField } from "../../components/global";

interface ModalTalentFilterProps {
  open: boolean;
  onClose: () => void;
}

const ModalTalentFilter = ({ open, onClose }: ModalTalentFilterProps) => {
  const filter = useAppSelector((state: RootState) => state.ui.talentFilter);
  const dispatch = useAppDispatch();

  const [city, setCity] = React.useState(filter.city);
  const [state, setState] = React.useState(filter.state);

  const handleReset = React.useCallback(() => {
    // TODO: still triggered double refresh
    setCity("");
    setState("");
    dispatch(setTalentFilter({}));
  }, [dispatch]);

  const debounceCity = useDebounce(city, 500);
  const debounceState = useDebounce(state, 500);

  React.useEffect(() => {
    dispatch(setTalentFilter({ ...filter, city: debounceCity }));
  }, [dispatch, debounceCity]);

  React.useEffect(() => {
    dispatch(setTalentFilter({ ...filter, state: debounceState }));
  }, [dispatch, debounceState]);

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Filter By"
      maxWidth="xs"
      useGlassCard={false}
      footer={
        <>
          <Button 
            variant="outlined" 
            onClick={handleReset}
            sx={{
              borderColor: "#F4A259",
              color: "#F4A259",
              "&:hover": {
                backgroundColor: "rgba(244, 162, 89, 0.08)",
                borderColor: "#F4A259",
              },
            }}
          >
            Reset
          </Button>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      <Box sx={{ p: 3 }}>
        <Stack spacing={2}>
          <SelectSkills
            onChange={(ids) =>
              dispatch(setTalentFilter({ ...filter, skills: ids }))
            }
            values={filter.skills || []}
          />
          <StyledTextField
            label="City"
            value={city || ""}
            fullWidth
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
          />
          <StyledTextField
            label="State"
            value={state || ""}
            fullWidth
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setState(e.target.value)}
          />
          <SelectCountry
            onChange={(id) =>
              dispatch(setTalentFilter({ ...filter, country: id }))
            }
            value={filter.country || 0}
          />
        </Stack>
        </Box>
    </BaseModal>
  );
};
export default ModalTalentFilter;
